import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              PERMITANME <span className="purple"> PRESENTARME </span> 
            </h1>
            <p className="home-about-body">
              Soy un Desarrollador de software especializado en backend.
              Siempre que es posible, aplico mis conocimientos en el desarrollo de productos con
              <i>
                <b className="purple">  Java, el Framework Spring Boot y Microservicios. </b> 
              </i>
              <br />
              <br />
              Actualmente, estoy cursando
              <i>
                <b className="purple"> Ingeniería en Sistemas </b> 
                 en la 
                <b className="purple"> Universidad Tecnológica Nacional (UTN) </b>,
                 ya que quiero seguir desarrollando aun mas mis conocimientos.
              </i>
              <br />
              <br />
              Siempre estoy en constante aprendizaje de nuevas tecnologías y con el entusiasmo de contribuir a 
              proyectos desafiantes e innovadores
              <br />
              <br />
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>PUEDEN CONTACTARME POR:</h1>
          
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Jonathan-Romano"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/jonathan-romano-670639212/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/joni_romanof/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
